export enum OriginOfMerchantEnum {
  'Amber' = 1,
  'SureSystems',
  'MediBucks',
  'Collexia'
}

export namespace OriginOfMerchantEnum {
  export function values() {
    return Object.keys(OriginOfMerchantEnum).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}



